import { FileUpload } from '../upload/FileUpload'
import { UploadPanel } from '../landing/UploadPanel'
import { RightPanel, WelcomeContent } from '../landing/WelcomePanel'
import { DraftBanner } from '../landing/DraftBanner'
import { MenuDraft } from '../../utils/menuDraft'

interface LandingScreenProps {
  onFilesAdded: (files: File[]) => void
  error: string | null
  draft: MenuDraft | null
  onResumeDraft: () => void
  onDiscardDraft: () => void
}

export const LandingScreen = ({ onFilesAdded, error, draft, onResumeDraft, onDiscardDraft }: LandingScreenProps) => (
  <div className="h-screen flex overflow-hidden relative">
    <UploadPanel>
      {draft && <DraftBanner savedAt={draft.savedAt} onResume={onResumeDraft} onDiscard={onDiscardDraft} />}
      <FileUpload
        onFileUpload={onFilesAdded}
        className="border-2 border-dashed border-gray-400 rounded-lg p-12 text-center bg-brand-secondary/20 backdrop-blur-sm w-full"
      />
      {error && (
        <div className="mt-4 p-4 bg-red-900/50 backdrop-blur-sm rounded-lg">
          <p className="text-red-300 text-sm">{error}</p>
        </div>
      )}
    </UploadPanel>

    <RightPanel>
      <WelcomeContent />
    </RightPanel>
  </div>
)
